import styled from "styled-components";
import { Form } from "antd";

export const FormStyled = styled(Form)`
  display: ${(props) => (props.column == 2 ? "flex" : "flex")};
  flex-wrap: ${(props) => (props.column == 2 ? "wrap" : "wrap")};

  .ant-form-item {
    width: ${(props) => (props.column == 2 ? "50%" : "100%")};
    margin-bottom: 3px;
    display: flex;
    align-self: start;

    input[disabled] {
      color: gray;
    }

    & input[type="text"],
    & input[type="password"] {
      padding: 0.8vw 5px 0.8vw 15px;
      font-size: 16px;

      @media only screen and (max-width: 768px) {
        font-size: 16px;
        height: 40px !important;
      }

      @media screen and (min-width: 1200px) {
        font-size: 16px;
      }
    }

    .ant-select-selector {
      font-size: 16px;
      height: 50px !important;
      align-items: center;
      padding: 0.8vw 5px 0.8vw 15px;

      .ant-select-selection-search-input {
        padding: 5px;
      }

      @media only screen and (min-width: 1200px) {
        height: 50px !important;
        font-size: 16px;
      }

      @media only screen and (max-width: 768px) {
        font-size: 16px;
        height: 40px !important;
      }

      @media only screen and (max-width: 450px) {
        padding: 5px 10px !important;
      }

      @media only screen and (max-width: 376px) {
        padding: 5px 7px !important;
      }

      @media screen and (min-width: 1900px) {
        font-size: 16px;
      }
    }

    .ant-form-item-label {
      padding-bottom: 3px;
      label {
        padding: 0px;
        font-size: 18px;

        @media only screen and (max-width: 768px) {
          font-size: 16px;
        }

        @media screen and (min-width: 1200px) {
          font-size: 18px;
        }
      }
    }

    .ant-input-affix-wrapper {
      padding: 0px;
    }
    .ant-input-suffix {
      margin-right: 6px;
    }

    .ant-form-item-explain {
      font-size: 16px;
      @media only screen and (max-width: 768px) {
        font-size: 12px;
      }
      @media only screen and (max-width: 376px) {
        font-size: 10px;
      }
    }

    @media only screen and (max-width: 767.9px) {
      width: ${(props) => (props.column == 2 ? "100%" : "100%")};
      display: block;
    }
  }

  .ant-picker,
  .ant-input-number {
    width: 100%;
    height: 50px !important;
    font-size: 16px;

    @media only screen and (min-width: 1200px) {
      height: 50px !important;
    }

    @media only screen and (max-width: 450px) {
      height: auto;
      font-size: 16px;
    }

    @media only screen and (max-width: 768px) {
      height: 40px !important;
      font-size: 18px;
    }
  }

  .ant-picker-input {
    font-size: 16px;
    input {
      @media only screen and (min-width: 768px) and (max-width: 1280px) {
        height: 60px !important;
        font-size: 18px;
      }
      @media only screen and (max-width: 767.9px) {
        height: auto;
        font-size: 16px;
      }
    }
  }

  .ant-input-number-handler-wrap {
    display: none;
  }

  .ant-form-item-required {
    display: flex;
    &::before {
      margin-left: 1px;
      order: 1;
    }
  }

  /* ${(props) =>
    props.customFormButton
      ? ""
      : ` */
     .form-button{
        justify-content: center;
        width: 100% !important;

        .ant-form-item-control-input-content{
            display: flex;
            justify-content: center;
            /* padding: 10px 50px !important; */
            margin-top: 2vw;
            margin-bottom: 20px;
            

            & > button{ 

              @media only screen and (max-width: 768px){
                  min-width: 180px; 
                  min-height: 40px;
                  font-size: 16px; 
              }
              @media only screen and (max-width: 450px){
                  min-width: 150px; 
                  font-size: 16px; 
              }
              @media only screen and (max-width: 376px){
                  min-width: 140px; 
                  font-size: 14px; 
              }
              @media only screen and (min-width: 1200px){
                 font-size: 16px; 
                 min-height: 46px;
                 min-width : 14vw;
              } 
            }

            & > button:not(:first-child){
                margin-left: 10px;               
            }      
        }
    }
  /* `}; */
`;
